module.exports = __webpack_public_path__ + "static/media/downloadLeft.60f993ae.webp";